import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { compose } from 'redux';

import { getQueryParams } from '../../lib/query-param-helpers';

export const withFilters = (WrappedComponent) => {
  const FiltersReflectedComponent = ({
    queryParamName,
    queryParamValue,
    filterByQueryParam,
    history,
    ...props
  }) => {
    const queryParams = getQueryParams(history);
    const queryParamsList = useMemo(
      () =>
        (typeof queryParamValue === 'string' &&
          queryParamValue
            .split('|')
            .map((value) => (value === 'default' ? '' : value.trim()))
            .filter(Boolean)) ||
        [],
      [queryParamValue]
    );

    if (
      filterByQueryParam &&
      queryParams[queryParamName] &&
      !queryParamsList.includes(queryParams[queryParamName])
    ) {
      return null;
    }

    return (
      <WrappedComponent
        queryParamName={queryParamName}
        queryParamValue={queryParamValue}
        filterByQueryParam={filterByQueryParam}
        history={history}
        {...props}
      />
    );
  };

  FiltersReflectedComponent.propTypes = {
    filterByQueryParam: PropTypes.bool,
    queryParamName: PropTypes.string,
    queryParamValue: PropTypes.string,
    history: PropTypes.object,
  };

  FiltersReflectedComponent.defaultProps = {
    filterByQueryParam: false,
  };

  FiltersReflectedComponent.getEditingConfig =
    WrappedComponent.getEditingConfig;
  FiltersReflectedComponent.isContainer = WrappedComponent.isContainer;
  FiltersReflectedComponent.displayName = `withFilters (${WrappedComponent.displayName})`;

  return compose(withRouter)(FiltersReflectedComponent);
};
